export function mapRarityStrToNum(rarity?: string) {
  if (rarity === 'Unknown') return 0
  if (rarity === 'Common') return 1
  if (rarity === 'Uncommon') return 2
  if (rarity === 'Rare') return 3
  if (rarity === 'Epic') return 4
  if (rarity === 'Legendary') return 5
  return 0
}
